<template>
  <div class="account-menu">
    <active-button
      class="account-menu-item"
      line-color="blue"
      line-position="left"
      :active="isActive('view', 'bets')"
      @click="click('bets')"
    >
      <div class="account-menu-item-icon">
        <i-clover :title="null" />
      </div>
      <div class="account-menu-item-name">{{ $t('menu.bets') }}</div>
    </active-button>
    <!--active-button
      class="account-menu-item"
      line-color="blue"
      line-position="left"
      :active="isActive('view', 'payments')"
      @click="click('payments/withdrawal')"
    >
      <div class="account-menu-item-icon">
        <i-credit-card :title="null" />
      </div>
      <div class="account-menu-item-name">{{ $t('menu.payments') }}</div>
    </active-button-->
    <active-button
      class="account-menu-item"
      line-color="blue"
      line-position="left"
      :active="isActive('view', 'profile')"
      @click="click('profile')"
    >
      <div class="account-menu-item-icon">
        <i-account-details :title="null" />
      </div>
      <div class="account-menu-item-name">{{ $t('menu.profile') }}</div>
    </active-button>
    <!--active-button
      class="account-menu-item"
      line-color="blue"
      line-position="left"
      :active="isActive('view', 'bonuses')"
      @click="click('bonuses')"
    >
      <div class="account-menu-item-icon">
        <i-wallet-giftcard :title="null" />
      </div>
      <div class="account-menu-item-name">{{ $t('menu.bonuses') }}</div>
    </active-button-->
  </div>
</template>

<script>
import IClover from 'vue-material-design-icons/Clover'
import ICreditCard from 'vue-material-design-icons/CreditCard'
import IAccountDetails from 'vue-material-design-icons/AccountDetails'
import IWalletGiftcard from 'vue-material-design-icons/WalletGiftcard'
import IExitToApp from 'vue-material-design-icons/ExitToApp'
import ActiveButton from '@/components/buttons/ActiveButton'

export default {
  components: {
    IClover,
    ICreditCard,
    IAccountDetails,
    IWalletGiftcard,
    IExitToApp,
    ActiveButton
  },
  methods: {
    click (view) {
      if (this.isActive('view', view)) return
      this.$router.push(`/account/${view}`)
    }
  }
}
</script>

<style scoped>
.account-menu-item { cursor: pointer; display: flex; height: 40px; line-height: 40px; padding-right: 12px; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; }
.account-menu-item:hover { background: rgba(255, 255, 255, .1); }
.account-menu-item.active { background: #8c9eff; cursor: default; }
.account-menu-item-icon { align-items: center; display: flex; font-size: 18px; justify-content: center; padding: 0 11px; }
</style>



// WEBPACK FOOTER //
// src/components/account/Menu.vue